

export default class PrestadorContrasena{
    IdPss:number
    ContrasenaAnterior:string =""
    ContrasenaNueva:string =""
    ContrasenaConfirmacion:string = ""
}